// extracted by mini-css-extract-plugin
export default {"NewsPreview__Template":"NewsPreview_NewsPreview__Template__0U-pS"};